/**
 * Created by xinjundong on 2017/11/21.
 */
import axios from 'axios'
// '//app.auto.sohu.com/api'
// http://api.aves.auto.sohuno.com

let instance = axios.create({
  baseURL: InterfaceUrl
})
export function getHots () {
  return instance.get('/feeds/hot')
}

export function getRecs (maxId) {
  if (maxId) {
    return instance.get('/feeds/recommended', {
      params: {
        max_id: maxId
      }
    })
  } else {
    return instance.get('/feeds/recommended')
  }
}

export function getContent (newsId) {
  return instance.get('/news/' + newsId + '/detail')
}

export function shareVisit (data) {
  return instance.post('https://app.auto.sohu.com/api/usertasks-static/share/visit', data)
}



// WEBPACK FOOTER //
// ./src/api/api.js